module.exports = __webpack_public_path__ + "static/media/unbound7.e80c2513.png";